import { useState, useCallback } from 'react';

import { TabType } from '../types';

const useActiveTab = (initialTab: TabType = 'dashboard') => {
  const [activeTab, setActiveTab] = useState<TabType>(initialTab);

  const handleTabChange = useCallback((tab: TabType) => {
    setActiveTab(tab);
  }, []);

  return {
    activeTab,
    setActiveTab: handleTabChange,
  };
};

export default useActiveTab;
